import { PaymentDocument } from './payment-document';
import { SpecialInvoiceType } from './special-invoice-type';

export interface Payment {
  documents: PaymentDocument[];
  paymentReference?: string;
  specialInvoice?: SpecialInvoiceType;
}
